import React, { Component } from "react";
import { useParams } from "react-router-dom";
import "./Statistics.css";
import axios from "../api/axios.js";
import Footer from "../Components/Footer.js";
import HomeNavbar from "../HomeNavbar.js";
import InfoTable from "../Components/InfoTable.js";
import { useState } from "react";
import { useEffect } from "react";
import SmallLoading from "../Components/smallLoading.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StatsBox from "../Components/StatsPage/StatsBox.js";
import ErrorMessage from "../Components/RecordPage/ErrorMessage.js";
import MoleculeBrowser from "../Components/BrowsePage/MoleculeBrowse.js";
import { useNavigate } from "react-router-dom";
import MechanismBrowser from "../Components/BrowsePage/MechanismBrowser.js";
import EnzymeBrowser from "../Components/BrowsePage/EnzymeBrowser.js";
import renderSearchResults from "../api/renderSearchResults.js";
import MechanismWindow from "../Components/MechanismTable/mechanismWindow.js";
import MechanismTable from "../mechanismTable.js";

function BrowsePage(){

    const { mode } = useParams();

    const [mechBody, setMechBody] = useState([]);

    const navigate = useNavigate()

    
    
    const navigateToRecord = (recordId) => {
        navigate(`/record/${recordId}`);
    }

    const getModePageComponent = () => {
      console.log("getModePageComponent mode", mode);
        if (mode == "molecules") {
          console.log("Molecule mode");
            return (
                <MoleculeBrowser searchResult={"nothing"} setMechBody={setMechBody} navigateToRecord={navigateToRecord} />
            )
        }  else if (mode == "mechanisms") {
            console.log("Mechanism mode");
            return (
                <MechanismBrowser searchResult={"nothing"} setMechBody={setMechBody} navigateToRecord={navigateToRecord} />
            )
        }
        else if (mode == "enzymes") {
            console.log("Enzyme mode");
            return (
                <EnzymeBrowser setMechBody={setMechBody} navigateToRecord={navigateToRecord} />
            )
        } 
        else {
            console.log("Unknown mode");
            return <ErrorMessage message={`Unknown browsing mode.`} />;
        }
        return null;
    };



    return (
        <div id="statsbody">
        <HomeNavbar />
      <div id="basicpage">
                {getModePageComponent()}       
      </div>
        <Footer />

         <MechanismWindow>
        <MechanismTable
          heading={[
            "Intermediate substrate",
            "Intermediate product",
            "Mechanism type",
          ]}
          body={mechBody}
        />
      </MechanismWindow>
        </div>      
        );



}

export default BrowsePage;